import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const DARK_THEMES = ["dark", "ink", "galilee", "vine"];
const savedTheme = localStorage.getItem("attune_theme");
if (savedTheme) {
  if (DARK_THEMES.includes(savedTheme)) {
    document.documentElement.classList.add("dark");
  }
  if (savedTheme !== "dark" && savedTheme !== "light") {
    document.documentElement.classList.add(`theme-${savedTheme}`);
  }
}

const QUERY_STALE_TIME_MS = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
